module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', {
    staticClass: "loginForm"
  }, [_c('column', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-4"
  }, [_c('h2', {
    staticClass: "widget-user-username",
    staticStyle: {
      "margin-left": "0px"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('va-box', {
    attrs: {
      "title": "Login",
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keyup": function($event) {
        return _vm.loginKeyup($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keyup": function($event) {
        return _vm.loginKeyup($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10",
    staticStyle: {
      "text-align": "right",
      "cursor": "pointer"
    }
  }, [_c('a', {
    staticClass: "control-label",
    on: {
      "click": function($event) {
        return _vm.sendResetPassword()
      }
    }
  }, [_vm._v("Reset Password")])])]), _vm._v(" "), _c('div', {
    staticClass: "tree-content tree--small col-sm-offset-2 col-sm-10",
    staticStyle: {
      "float": "left!important"
    },
    on: {
      "click": function($event) {
        _vm.rememberMe = !_vm.rememberMe
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.rememberMe ? 'checked' : '']
  }), _vm._v(" "), _c('span', {
    staticClass: "tree-anchor",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('span', {
    staticClass: "tree-text",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("Remember me")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "primary",
      "name": "Register"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.register($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    attrs: {
      "isBlock": false,
      "theme": "danger",
      "name": "Cancel",
      "align": "right"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }), _vm._v(" "), _c('va-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "isBlock": false,
      "theme": "success",
      "align": "right",
      "name": "Login"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.login($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('va-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    attrs: {
      "type": _vm.alertType,
      "dismissible": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [(_vm.alertType === 'success') ? _c('i', {
    staticClass: "icon fa fa-check"
  }) : _c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" " + _vm._s(_vm.error) + "\n      ")])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-4"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e355cb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VALogin.vue
// module id = 715
// module chunks = 0